import ManualFindBar from './ManualFindBar';

export default ManualFindBar;
